import { IOrganization, IProfile } from '../../../interfaces/graph-types';
import { OrganizationService } from './../../../services/organization.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'profile',
  template: require('./profile.component.pug'),
  styles: [require('./profile.component.css').toString()],
})
export class ProfileComponent implements OnInit {
  @Input()
  profile: IProfile;

  @Input()
  size: number;

  @Input()
  tooltip: string = null;

  // -------------------------------------------------------------------
  constructor() {}

  // -------------------------------------------------------------------
  ngOnInit() {
    if (!this.size) {
      this.size = 48;
    }
  }

  // -------------------------------------------------------------------
  getSize() {
    return this.size.toString() + 'px';
  }
}
